export const visit = (vm, at) => {
at({ "ca-es": { "conversationsVisitorUIAvailability": { "sameDay": "Tornarem avui a les {{time}}", "nextDay": "Tornarem dem\xE0 a les {{time}}", "nextWeek": "Tornarem {{dayOfWeek}} a les {{time}}" } } });
};